import axios from "axios";
import { API } from "../config";


class MotivoSituacaoService {
    novoMotivoSituacao(situacaoJuridica) {
        return axios.post(API + "/motivo-situacao", situacaoJuridica);
    }

    listarMotivoSituacao() {
        return axios.get(API + "/motivo-situacao")
    }

    getMotivoSituacao(id) {
        return axios.get(API + "/motivo-situacao/" + id)
    }
    atualizarMotivoSituacao(id, situacaoJuridica) {
        return axios.put(API + "/motivo-situacao/" + id, situacaoJuridica);
    }
    inativarMotivoSituacao(id, situacaoJuridica) {
        return axios.post(API + "/motivo-situacao/" + id + "/inativar", situacaoJuridica);
    }
    reativarMotivoSituacao(id, situacaoJuridica) {
        return axios.post(API + "/motivo-situacao/" + id + "/reativar", situacaoJuridica);
    }
    pesquisarMotivoSituacao(descricao, status, tipo, risco, extincaoPoderFamiliar) {
        return axios.get(API + "/motivo-situacao/search", {
            params: {
                descricao: descricao !== "" ? descricao : undefined,
                status: status !== "" ? status : undefined,
                tipoSituacaoId: tipo !== "" ? tipo : undefined,
                risco: risco !== "" ? risco : undefined,
                extincaoPoderFamiliar: extincaoPoderFamiliar !== "" ? extincaoPoderFamiliar : undefined
            }
        });
    }
}

const instanceMotivoSituacao= new MotivoSituacaoService();
export default instanceMotivoSituacao;